import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Subject, takeUntil } from 'rxjs';

import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-update-in-progress-alert',
    templateUrl: './update-in-progress-alert.component.html',
    styleUrls: ['./update-in-progress-alert.component.scss'],
    imports: [TranslateModule],
})
export class UpdateInProgressAlertComponent implements OnInit, OnDestroy {
    private readonly swUpdate = inject(SwUpdate);

    public showAlert = false;
    #unsubscribe = new Subject<void>();

    ngOnInit(): void {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.versionUpdates.pipe(takeUntil(this.#unsubscribe)).subscribe((event) => {
                if (event.type === 'VERSION_DETECTED') {
                    this.showAlert = true;
                } else {
                    this.showAlert = false;
                }
            });
        }
    }

    ngOnDestroy() {
        this.#unsubscribe.next();
        this.#unsubscribe.complete();
    }
}
